import React from 'react'
import styled from 'styled-components'
import logo from '../imagenes/284155446_5051543411565338_4169603858621060659_n.jpg'
import { Icon } from '@iconify/react/dist/iconify.js'


const Prop = ({ titulo, icono }) => {
    return (
        <>
            <Imagen src={logo} />
            <Container>
                <Titulo>
                    <h1 style={{ fontSize: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>{titulo}</h1>
                </Titulo>
                <Circulo>
                    <Icon icon={icono} style={{ fontSize: '36px' }} />
                </Circulo>
            </Container>
        </>
    )
}

const Imagen = styled.img`
    width: 100vw;
    height: 500px;
`
const Container = styled.div`
    transform: translateY(-60%);
    padding: 15px;
    margin: auto;
    border-radius: 20px;
    width: 60vw;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: relative;
    background-color: var(--secundary);
    color: white;
`
const Titulo = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Circulo = styled.div`
    border-radius: 50%;
    box-shadow: 0 -4px 10px white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
    color: white;
    background-color: var(--secundary);
    position: absolute;
    bottom: 0;
    transform: translateY(50%);
`

export default Prop